export function getBoolColor(value) {
    if (value === true)
        return "brand-success-600";
    if (value === false)
        return "brand-danger-500";
    return "gray-500";
}
